import LoyaltyMembersDayBanner from "../../containers/MembersDay";
import addLoyaltyBanner from "../../helpers/addLoyaltyBanner";

const addLoyaltyMembersDayBanner = ({
  viewportCategory,
  positionFinder,
  items
}) =>
  addLoyaltyBanner({
    viewportCategory,
    positionFinder,
    items,
    BannerComponent: <LoyaltyMembersDayBanner key="loyaltyMembersDayBanner" />
  });

export default addLoyaltyMembersDayBanner;
